import React from 'react';
import { Button } from 'amphitheatre';

export function AmphitheatreButtonWrapper({
  className,
  ...rest
}: {
  className: string;
  [k: string]: unknown;
}) {
  return (
    <div className={className}>
      <Button {...rest} />
    </div>
  );
}
